export enum PermissionTypeEnum {
	VISUALIZAR = 'Visualizar',
	APROVAR_REJEITAR = 'AprovarRejeitar'
}

